import {
    HeartHandshake,
    ScaleIcon,
    ShieldCheck,
    Sparkles,
    HandHeart,
    Lightbulb,
} from "lucide-react";

export const values = [
    {
        title: "Responsabilidad Social",
        description:
            "Compromiso con el bienestar colectivo y el desarrollo de los sectores más vulnerables del estado Falcón.",
        Icon: HeartHandshake,
        tone: "green",
    },
    {
        title: "Transparencia y Equidad",
        description:
            "Gestión pública abierta, verificable y justa en cada proceso administrativo y operativo.",
        Icon: ScaleIcon,
        tone: "gold",
    },
    {
        title: "Integridad",
        description:
            "Actuación ética y coherente entre lo que se dice y lo que se hace, en todos los niveles institucionales.",
        Icon: ShieldCheck,
        tone: "green",
    },
    {
        title: "Excelencia",
        description:
            "Búsqueda constante de la mejora continua y la calidad en los servicios prestados al ciudadano.",
        Icon: Sparkles,
        tone: "gold",
    },
    {
        title: "Solidaridad",
        description:
            "Apoyo activo y sostenido a programas sociales que impulsan la dignidad de la población falconiana.",
        Icon: HandHeart,
        tone: "green",
    },
    {
        title: "Innovación",
        description:
            "Adopción de tecnología de punta y nuevas prácticas para modernizar la gestión pública del sector.",
        Icon: Lightbulb,
        tone: "gold",
    },
];
